import { formatValue } from "../../utils/constants/company-stats"
import { Locale } from "../../utils/locales/constants"

export type StructuredTextRecord = {
  record: unknown
}
type FormattedCompanyStats = {
  __typename: "DatoCms_FormattedCompanyStatisticRecord"
  format: "fullWord" | "singleLetter" | "numerical"
  link?: string
  value: {
    baseValue: number
    unit: number
    title: string
  }
}
export const isCompanyStatsInlineLink = (
  record: unknown,
): record is FormattedCompanyStats =>
  typeof record === "object" &&
  !!record &&
  "__typename" in record &&
  record.__typename === "DatoCms_FormattedCompanyStatisticRecord"

export const getCompanyStatsString = (
  record: FormattedCompanyStats,
  locale: Locale,
) => {
  const {
    value: { baseValue, unit },
    format,
  } = record
  const value = baseValue * unit
  return formatValue(value, format, locale)
}
